import { render, staticRenderFns } from "./ChatFlowViewSidebar.vue?vue&type=template&id=15aa1928&scoped=true"
import script from "./ChatFlowViewSidebar.vue?vue&type=script&lang=js"
export * from "./ChatFlowViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatFlowViewSidebar.vue?vue&type=style&index=0&id=15aa1928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa1928",
  null
  
)

export default component.exports